import { defineStore } from 'pinia'
import axios from 'axios'
import { useAuthStore } from './auth'

const API_BASE = 'https://backend.controlease.com.br/api/billing'

export const useBillingStore = defineStore('billing', {
  state: () => ({
    plans: [],
    status: {
      hasActive: false,
      statusAssinatura: null,
      plano: null,
      stripeCustomerId: null,
      stripeSubscriptionId: null,
      currentPeriodEnd: null,
    },
    loadingPlans: false,
    loadingStatus: false,
    loadingCheckout: false,
    loadingPortal: false,
    error: null,
  }),

  actions: {
    async fetchPlans() {
      this.loadingPlans = true
      this.error = null
      try {
        const res = await axios.get(`${API_BASE}/plans`)
        this.plans = Array.isArray(res.data) ? res.data : []
      } catch (err) {
        this.error = 'Não foi possível carregar os planos.'
      } finally {
        this.loadingPlans = false
      }
    },

    async fetchStatus() {
      this.loadingStatus = true
      this.error = null
      try {
        const authStore = useAuthStore()
        const res = await axios.get(`${API_BASE}/status`, {
          headers: {
            Authorization: `Bearer ${authStore.token}`,
          },
        })

        const data = res.data || {}

        this.status.hasActive = data.hasActive === true
        this.status.statusAssinatura = data.statusAssinatura || null
        this.status.plano = data.plano || null
        this.status.stripeSubscriptionId = data.stripeSubscriptionId || null
        this.status.currentPeriodEnd = data.currentPeriodEnd || null
        this.status.stripeCustomerId = data.stripeCustomerId || this.status.stripeCustomerId || null
      } catch (err) {
        this.error = 'Não foi possível carregar o status da assinatura.'
      } finally {
        this.loadingStatus = false
      }
    },

    async startCheckout(planId) {
      this.loadingCheckout = true
      this.error = null
      try {
        const authStore = useAuthStore()
        const res = await axios.post(
          `${API_BASE}/checkout`,
          { planId },
          {
            headers: {
              Authorization: `Bearer ${authStore.token}`,
              'Content-Type': 'application/json',
            },
          }
        )

        const checkoutUrl = res.data?.url
        if (checkoutUrl) {
          window.location.href = checkoutUrl
        } else {
          this.error = 'Resposta inválida do servidor.'
        }
      } catch (err) {
        this.error = err?.response?.data?.message || 'Não foi possível iniciar o checkout.'
      } finally {
        this.loadingCheckout = false
      }
    },

    async openPortal() {
      this.loadingPortal = true
      this.error = null
      try {
        const authStore = useAuthStore()
        const res = await axios.post(
          `${API_BASE}/portal`,
          {
            subscriptionId: this.status.stripeSubscriptionId || null,
          },
          {
            headers: {
              Authorization: `Bearer ${authStore.token}`,
              'Content-Type': 'application/json',
            },
          }
        )

        const portalUrl = res.data?.url
        if (portalUrl) {
          window.location.href = portalUrl
        } else {
          this.error = 'Resposta inválida do servidor.'
        }
      } catch (err) {
        this.error = 'Não foi possível abrir o portal de cobrança.'
      } finally {
        this.loadingPortal = false
      }
    },
  },
})
